import moment from 'moment';
import LoadingCircle from '../components/LoadingCircle'

export default class PlanIndex {

    constructor() {
        this.firstNameField     = $('#first-name-field')
        this.lastNameField      = $('#last-name-field')
        this.emailField         = $('#email-address-field')
        this.companyField       = $('#company-field')
        this.addressField       = $('#address-field')
        this.apartmentField     = $('#apartment-field')
        this.cityField          = $('#city-field')
        this.regionField        = $('#region-field')
        this.postalCodeField    = $('#postal-code-field')
        this.countryField       = $('#country-field')
        this.cardNameField      = $('#card-name-error')

        this.firstNameError     = $('#first-name-error')
        this.lastNameError      = $('#last-name-error')
        this.emailError         = $('#email-address-error')
        this.companyError       = $('#company-error')
        this.addressError       = $('#address-error')
        this.apartmentError     = $('#apartment-error')
        this.cityError          = $('#city-error')
        this.regionError        = $('#region-error')
        this.postalCodeError    = $('#postal-code-error')
        this.countryError       = $('#country-error')
        this.promoCodeError     = $('#promo-code-error')

        this.planError          = $('#plan-error')
        this.billingCycleError  = $('#billing-cycle-error')

        this.cardError          = $('#card-error')

        this.promoCodeField     = $('#promo-code-field')

        this.loading_circle = new LoadingCircle()


        this.selectedPlanId = null
        this.selectedPriceId = null
        this.stripe = Stripe(stripe_client_id);
        this.elements = this.stripe.elements();

        this.style = {
            base: {
              fontSize: '16px',
              color: '#32325d',
            },
        };
        this.cardElement = this.elements.create('card');
        this.cardElement.mount('#card-element')
        this.cardHolderName = $('#card-holder-name');
        this.cardHolderNameError = $('#card-name-error');


        this.form = $('#subscription-form')
        this.reviewOrderBtn = $('#review-order-btn')

        this.checkPromoCodeBtn = $('#check-promo-code-btn')

        this.addonSection = $('#add-on-section')
        this.camoPartnerBtn = $('#camo-partner-container')
        this.addonTable=$("#addons-plan-selection-list");
        this.selectedPriceInterval="month"
        this.addonLicensesClassToggle=$("#addon-licenses-class-toggle");
        this.events()
        this.onLoad()
    }

    events() {

        /**
         *      Clearing form errors
         */
        this.firstNameField.on('input changed paste', e => this.firstNameError.text(''))
        this.lastNameField.on('input changed paste', e => this.lastNameError.text(''))
        this.emailField.on('input changed paste', e => this.emailError.text(''))
        this.addressField.on('input changed paste', e => this.addressError.text(''))
        this.cityField.on('input changed paste', e => this.cityError.text(''))
        this.postalCodeField.on('input changed paste', e => this.postalCodeError.text(''))
        this.countryField.on('input changed paste', e => this.countryError.text(''))
        this.cardHolderName.on('input changed paste', e => this.cardHolderNameError.text(''))
        this.countryField.on('change', e => this.regionField_Changed(e))

        $('#privacy_policy').on('change', e => $('#privacy_policy_error').text(''))
        $('#check-promo-code-btn').on('click', e => this.checkPromoCodeBtn_Clicked(e))
        $('#promo-code-field').on('input changed paste', e => this.promoCodeField_Changed(e))

        this.cardElement.on('focus',    (event) => this.cardError.text(''));
        this.cardElement.on('blur',     (event) => this.cardError.text(''));
        this.cardElement.on('escape',   (event) => this.cardError.text(''));
        this.cardElement.on('input',    (event) => this.cardError.text(''));
        this.cardElement.on('change',   (event) => this.cardError.text(''));

        this.form.on('submit', e => this.formSubmit(e))
        $('#plan-list').on('click change', 'input', e => this.show($(e.currentTarget).data('plan-id')));
        $('#billing-cycle-section').on('change', 'input', e => this.billingCycleChanged(e));
        $('#billing-cycle-section .billings').on('click change', 'input', e => {this.selectedPriceId = $(e.currentTarget).data('price-id'); this.billingCycleError.text('')} )
        this.reviewOrderBtn.on('click', e => this.reviewOrder(e))

        $('#card-element').on('input paste change click', 'input', e => this.cardError.text(''))

        $('#make-order-btn').on('click', e => this.makeOrder(e))
        // $(()=>{
            if(this.countryField.attr('defaultValue')){
                const country=this.countryField.attr('defaultValue');
                this.countryField.addClass('option-selected')
                this.countryField.val(country);
            }
            if(this.regionField.attr('defaultValue')){
                const region=this.regionField.attr('defaultValue');
                this.regionField.addClass('option-selected')
                this.regionField.val(region);
            }
        // })
        $('#review-order-modal').on('hidden.bs.modal', e => {
            $('#promo-code-total').removeClass('d-none')
            this.loading_circle.modalHide($('#review-order-modal .modal-body'))
            $('#close-review-modal-btn').removeClass('d-none')
            $('#review-order-modal .modal-footer').removeClass('d-none')
            $('#review-order-modal .modal-body .content').removeClass('d-none')
            $('#promo-code-total').removeClass('d-none')
        });

        this.camoPartnerBtn.on('click', (event) => {
            window.open('https://reincubate.com/checkout/?app=camo&voucher=KINO15', '_blank')
        });
    }

    onLoad() {
        this.index()

        $('#region').prop('disabled', true); //disable it at first
        $('#country').on('click', function() {
            if( $('#country').val() == 'US') {
            $('#region').prop('disabled', false);
            } else {
                $('#region').prop('disabled', true);
            }
        });

        $('#card-number-field').on('input change paste', evt => {
            document.querySelector('#card-number-field').value = document.querySelector('#card-number-field').value.replace(/[^0-9]/g, '');
            if(evt.which != 17 && evt.which != 8) {
                $('#card-number-field').val(function (index, value) {
                    return value.replace(/\W/gi, '').replace(/(.{4})/g, '$1 ');
                });
            }
        })


    }

    checkPromoCodeBtn_Clicked(e) {
        let loading_circle = new LoadingCircle()
        loading_circle.buttonShow($(e.currentTarget))

        axios.post(`/ajax/promo-code/${this.promoCodeField.val()}`, {
            plan_price_id: this.selectedPrice.id
        }).then(res => {
            this.checkPromoCodeBtn.attr('disabled', true)
            this.promoCodeError.text(res.data.description)
            loading_circle.buttonDisabled($(e.currentTarget))
        }).catch(err => {
            if(err.response.data) {
                if(err.response.data.promo_code) {
                    this.promoCodeError.text("" + err.response.data.promo_code[0])
                    this.promoCodeField.focus();
                }
            }
            loading_circle.buttonHide($(e.currentTarget))
        })
    }

    promoCodeField_Changed(e) {
        if(!this.promoCodeField.val().length) {
            this.checkPromoCodeBtn.attr('disabled', true)
            return
        }
        this.checkPromoCodeBtn.removeAttr('disabled')
        this.promoCodeError.text('')
    }

    regionField_Changed(e) {
        if(e.currentTarget.value == "US") {

            this.regionField.attr('disabled', false)
        } else {
            this.regionField.attr('disabled', true)
        }
    }

    formSubmit(e) {
        e.preventDefault()
        this.stripe.createToken(this.card).then((result) => {
            if (result.error) {
                var errorElement = document.getElementById('card-errors');
                errorElement.textContent = "" + result.error.message;
            } else {
                this.stripeTokenHandler(result.token);
            }
        });
    }

    stripeTokenHandler(token) {
        // Insert the token ID into the form so it gets submitted to the server
        var form = $('#payment-form')
        var hiddenInput = document.createElement('input');
        hiddenInput.setAttribute('type', 'hidden');
        hiddenInput.setAttribute('name', 'stripeToken');
        hiddenInput.setAttribute('value', token.id);
        form.append(hiddenInput);
        form.submit();
    }

    async index() {


        await axios.get(`/ajax/plans?options=all&payment=true`).then(res => {
            this.planList = res.data.filter(plan => {
                // plan type 1 => plan not addon || OLD METHOD
                return (plan.type_of == 1 && plan.visibility == 1 && plan.price > 0)
            });

            $('#plan-list').append(this.planList.map(plan => {
                // this.featuresToText(plan.features);
                if(!plan.qty){
                    plan.qty=plan.has_licenses ? Math.max(1,plan.min_licenses) : 1;
                }else{
                    plan.qty=Math.max(plan.qty,plan.min_licenses);
                }
                const selectedPrice=plan.plan_prices.find(p=>p.interval==this.selectedPriceInterval);
                const initialPrice=plan.qty * selectedPrice.price;
                const licensesHeader=`
                    <thead>
                        <tr>
                            <th class="header-transparent border-0 text-left">License</th>
                            <th class="header-transparent border-0 width-180px text-center">Price</th>
                            <th class="header-transparent border-0 text-center px-0 width-160px">Qty</th>
                        </tr>
                    </thead>
                `;

                const licensesBody=$('<tbody/>',{html:''});

                const licensesTable=$('<table/>',{
                    class:"w-100 table mb-0",
                    html:[licensesHeader,licensesBody]
                });

                if(plan.has_licenses){
                    const licenseName=$("<td/>",{
                        nowrap:'',
                        class:'vertical-align-middle border-0 px-2 py-2 sm-vertical-align-middle',
                        html:`<div class="d-flex align-items-center mb-1">
                            <div class="d-flex flex-column text-lg flex-1">
                                <span class="invoice-item-name text-invoice-amount text-lg sm-text-small">${plan.name}</span>
                        </div>
                       </div>`
                    });
            
                    const licensePrice=$("<td/>",{
                        class:"vertical-align-middle border-0 px-2 py-2 sm-vertical-align-middle",
                        html:`<div class="d-flex justify-content-center align-items-center mb-1">
                            <span class="invoice-line-amount text-invoice-amount text-lg sm-text-small">$${selectedPrice.price /100 }/${this.selectedPriceInterval == "month" ? "mo" : "y"}</span>
                        </div>`
                    });  

                    const licenseQtyInput=$("<input/>",{
                        class:"addon-qty-input sm-w-300px",
                        name:"purchase_license_qty_input",
                        type:"number",
                        style:'max-width:120px',
                        min:plan.min_licenses,
                        step:1,
                        value:plan.qty
                    }).on('change',()=>{
                        plan.qty=licenseQtyInput.val();
                        this.updatePlanRecurringPrice();
                        this.updateAddonMaxQty();
                    });
                    const licenseQtyMinus=$("<button/>",{
                        class:"mui-btn mui-btn--small mui-btn--gray mui-btn--fab",
                        html:`<i class="fa fa-minus" aria-hidden="true"></i>`
                    }).on('click',(e)=>{
                        e.preventDefault();
                        e.stopPropagation()
                        licenseQtyInput[0].stepDown();
                        licenseQtyInput.trigger('change')
                    })
                    const licenseQtyPlus=$("<button/>",{
                        class:"mui-btn mui-btn--small mui-btn--primary mui-btn--fab",
                        html:`<i class="fa fa-plus" aria-hidden="true"></i>`
                    }).on('click',(e)=>{
                        e.preventDefault();
                        e.stopPropagation()
                        licenseQtyInput[0].stepUp();
                        licenseQtyInput.trigger('change')
                    })
            
                    const licenseActionsContainer=$("<div/>",{
                        class:"d-flex justify-content-end align-items-start mb-1",
                        html:[licenseQtyMinus,licenseQtyInput,licenseQtyPlus]
                    })
                    const licenseActions=$("<td/>",{
                        class:"vertical-align-top border-0 px-0 py-1",
                        html:[licenseActionsContainer]
                    });

                    const licenseRow=$("<tr/>",{
                        html:[
                            licenseName,
                            licensePrice,
                            licenseActions
                        ]
                    })
                    licensesBody.append(licenseRow)
                }

                const tableContainer=$("<div/>",{
                    class:'licenses-table',
                    html:licensesTable
                });

                const planLicenses=$("<div/>",{
                    class:'plan-licenses',
                    html: tableContainer
                });

                const planLabel=$('<label/>',{
                    class:'label-custom-plans label-custom-plans-padding plan-line flex-column p-0',
                    for:plan['id'],
                    html:[
                        `<div class="d-flex w-100 plan-details-container">
                        <div class="d-flex justify-content-center align-items-center">
                            <div class="kino-checkbox square mr-2">
                                <input  type="radio" value="${plan.id}" name="plan_selected_checkbox" id="plan_checkbox_${plan.id}">
                                <label for="plan_checkbox_${plan.id}" class="pointer-events-none"></label>
                            </div>
                        </div>
                        <div class="plan-name-container d-flex justify-content-between flex-1">
                            <div class="invoice-item-name text-invoice-amount text-lg d-flex flex-column">
                                <span>Kino - ${plan['name']} ${plan.owned ? '(Current Plan)' : ''}</span>
                                <small>${this.featuresToText(plan.features)}</small>
                            </div>
                            <div class="invoice-line-amount text-invoice-amount text-lg" id="plan-${plan.id}-line-price">$${(initialPrice/100).toFixed(2)}</div>
                        </div>
                    </div>`,
                        plan.has_licenses ? planLicenses : ''
                    ]
                })
                const planrow=$('<div/>',{
                    class:'billing-method-radio radio-group plans-class-radio px-0 plan-line-row py-0',
                    html:[
                        `<input type="radio" id="${plan['id']}" name="selected_plan" value="" data-plan-id="${plan['id']}" class="input billing-input plans-class-input">`,
                        planLabel
                    ]
                });
                return $('<div/>',{
                    class:'w-100 pl-0 pr-0 mb-2',
                    html:planrow
                })
            }))

            let selected_plan = $('#current-plan-id').val()
            $(`#${selected_plan}`).prop("checked", true);
            this.selectedPlanId = selected_plan
        }).catch(err => {
            console.error(err)
        })

        await axios.get('/ajax/addons').then(res => {
            if(!res.data.length) {
                this.addonList = false;
                this.addonSection.addClass('d-none')
                return false;
            }

            this.addonSection.removeClass('d-none')
            this.addonList = res.data;
            this.addonList.forEach(addon => {
                this.renderAddon(addon);
            })
        }).catch(err => {
            console.error(err);
            this.addonList = false;
            return false;
        })
        this.show(this.selectedPlanId)
    }

    featuresToText(features){
        // console.log("Features",features);
        const featuresList=features.map(f=>{
            if(f.unit=="hours"){
                return `${f.feature_name} ${f.value > 0 ? f.value : '24'} ${f.unit}`
            }else if(f.unit=="participants"){
                return `${f.value > 0 ? 'Up to '+f.value : 'Unlimited'} ${f.unit}`
            }else if(f.unit=="licenses"){
                return `${f.value > 0 ? f.value : 'Unilimited'} licenses`
            }

            return '';
        });

        return featuresList.filter(text=>text.length > 0).join(", ")
    };

    renderAddon(addon){
        // const licenses=this.getLicenses();
        const addonName=$("<td/>",{
            class:`vertical-align-top border-0 px-0 py-2 row-type-${addon.type}`,
            html:`
            <div class="d-flex align-items-center">
            <div class="d-flex justify-content-center align-items-center hide-on-licenses ml-3">
                <div class="kino-checkbox square mr-2">
                    <input  type="checkbox" value="${addon.id}" name="addon_selected_checkbox" value="${addon.id}" id="addon_checkbox_${addon.id}" ${addon.selected ? 'checked' : ''}>
                    <label for="addon_checkbox_${addon.id}"></label>
                </div>
            </div>
            <div class="d-flex flex-column mb-1 text-lg">
                <span class="invoice-item-name text-invoice-amount text-lg">${addon.name}</span>
                <small class="invoice-item-desc">${addon.description}</small>
            </div>
            </div>`
        });

        const addonPrice=$("<td/>",{
            class:"vertical-align-top border-0 px-0 py-2 ",
            html:`<div class="d-flex justify-content-end align-items-center mb-1 price-cell">
                <span class="invoice-line-amount text-invoice-amount text-lg" id="purchase-addon-recurring-price${addon.id}">$${this.selectedPriceInterval == "month" ? (addon.month_price /100).toFixed(2) : (addon.year_price/100).toFixed(2)}</span>
            </div>`
        });

        const addonQtyInput=$("<input/>",{
            class:"addon-qty-input",
            name:"purchase_addon_qty_input",
            type:"number",
            min: this.hasLicenses() && addon.has_members > 0 && addon.type != 'workspace' ? addon.in_use : 0,
            step:1,
            'addon-id':addon.id,
            'addon-type':addon.type,
            'initial-qty':addon.qty,
            'initial-use' : addon.has_members > 0 ? addon.in_use : 0 ,
            max: addon.type != 'workspace' ? this.getLicenses() : 1000,
            value:addon.selected ? addon.qty : 0
        })//.on('change',this.onSelectionChanged.bind(manager));
        const addonQtyMinus=$("<button/>",{
            class:"mui-btn mui-btn--small mui-btn--gray mui-btn--fab",
            html:`<i class="fa fa-minus" aria-hidden="true"></i>`
        }).on('click',(e)=>{
            e.preventDefault()
            addonQtyInput.attr('initial-qty',0);
            addonQtyInput[0].stepDown();
            addonQtyInput.trigger('change')
        })
        const addonQtyPlus=$("<button/>",{
            class:"mui-btn mui-btn--small mui-btn--primary mui-btn--fab",
            html:`<i class="fa fa-plus" aria-hidden="true"></i>`
        }).on('click',(e)=>{
            e.preventDefault()
            addonQtyInput.attr('initial-qty',0);
            addonQtyInput[0].stepUp();
            addonQtyInput.trigger('change')
        })

        const addonActionsContainer=$("<div/>",{
            class:"d-flex justify-content-end align-items-start mb-1",
            html:[addonQtyMinus,addonQtyInput,addonQtyPlus]
        })
        const addonActions=$("<td/>",{
            class:"vertical-align-top border-0 px-0 py-1 show-on-licenses",
            html:[addonActionsContainer]
        });

        const addonRow=$("<tr/>",{
            class: `addon-type-${addon.type} ${!this.hasLicenses() && addon.type == 'workspace' ? 'addon-disabled' :''}`,
            for:`addon_checkbox_${addon.id}`,
            html:[addonName,addonPrice,addonActions],
        }).on('click',()=>{
            if(!this.hasLicenses() && addon.type != 'workspace'){
                if($(`#addon_checkbox_${addon.id}`).is(':checked')){
                    $(`#addon_checkbox_${addon.id}`).prop({checked:false})
                }else{
                    $(`#addon_checkbox_${addon.id}`).prop({checked:true})
                }
            }
        });
        if(!this.hasLicenses() && addon.type == 'workspace' ){
            addonRow.attr('data-toggle','tooltip')
            .attr('data-placement','top')
            .attr('data-original-title',`This add-on is not available on selected plan.`).tooltip();
        }
        this.addonTable.append(addonRow);
    };

    updateAddonRecurrinPrice(){
        if(this.addonList){
            this.addonList.forEach(addon=>{
                $(`#purchase-addon-recurring-price${addon.id}`).html(`$${this.selectedPriceInterval == "month" ? (addon.month_price /100).toFixed(2) : (addon.year_price/100).toFixed(2)}`)
            })
        }
    }

    updatePlanRecurringPrice(){
        if(this.planList){
            this.planList.forEach(plan=>{
                const price=plan.plan_prices.find(p=>p.interval==this.selectedPriceInterval);
                if(price){
                    $(`#plan-${plan.id}-line-price`).html(`$${((plan.qty*price.price)/100).toFixed(2)}`);
                }
            })
        }
    }
    updateAddonMaxQty(){
        const licenses=this.getLicenses();
        this.addonTable.find(`input[name=purchase_addon_qty_input]`).each((idx,el)=>{
            const type=$(el).attr('addon-type');
            if(type=='workspace'){
                $(el).attr('max',1000)
            }else{
                $(el).attr('max',licenses)
            }
            const initialQty=parseInt($(el).attr('initial-qty'));
            const inUse=parseInt($(el).attr('initial-use'));
            const currentQty=parseInt($(el).val());
            let minQty=0;
            if(!isNaN(inUse) && inUse > 0 && this.hasLicenses() && type!='workspace'){
                $(el).attr('min',inUse);
                minQty=inUse;
            }else{
                $(el).attr('min',0)
            }
            if(initialQty > 0){
                $(el).val(Math.min(Math.max(minQty,initialQty),licenses))
            }else{
                $(el).val(Math.min(Math.max(currentQty,minQty),licenses))
            }
        });
    }

    getSelectedAddonIds(){
        const selectedIds=[];
        this.addonTable.find(`input[name='purchase_addon_qty_input']`).each((i,input)=>{
            // console.log("checking addon",$(input).val())
            if(parseInt($(input).val()) > 0){
                selectedIds.push({id:parseInt($(input).attr('addon-id')),qty:parseInt($(input).val())});
            }
        })
        return selectedIds
    };

    getCheckboxSelectedAddons(){
        const selectedIds=[];
        this.addonTable.find(`input[name='addon_selected_checkbox']`).each((i,input)=>{
            // console.log("checking addon",$(input).val())
            if(parseInt($(input).val()) > 0 && $(input).is(':checked')){
                selectedIds.push({id:parseInt($(input).val()),qty:1});
            }
        })
        return selectedIds
    }

    getLicenses(){
        let licenses=0;
        if(this.selectedPlan && this.selectedPlan.has_licenses) {
            licenses=Math.max(this.selectedPlan.qty,this.selectedPlan.min_licenses);
        }
        return licenses;
    }

    hasLicenses(){
        if(this.selectedPlan && this.selectedPlan.has_licenses) {
            return true;
        }
        return false;
    }

    billingCycleChanged(e) {
        this.selectedPrice = this.selectedPlan.plan_prices.find(price => {
            return price.id == this.selectedPriceId
        })
        this.selectedPriceInterval = this.selectedPrice.interval;
        // console.log("Billing cycle changed : id = "+this.selectedPriceId,this.selectedPrice)
        this.updatePlanRecurringPrice();
        this.updateAddonRecurrinPrice();
        this.updateAddonMaxQty();

        if(this.selectedPlan.owned && this.selectedPrice && this.selectedPrice.id == this.selectedPlan.owned_price){
            this.disableOrderButton()
        }else{
            this.enableOrderButton();
        }
    }

    async show(plan_id) {
        if(!plan_id){return}
        // console.log("clicked plan",plan_id)
        this.planError.text('')
        // const previousLicenses=this.selectedPlanId ? this.getLicenses() : -1;
        this.selectedPriceId = null
        this.selectedPlanId = plan_id
        this.selectedPlan = null
        this.discount = 0;

        if(this.planList) {
            let plan = this.planList.find(plan => plan.id == this.selectedPlanId)
            if(plan) {
                this.selectedPlan = plan
            } else return false
        } else return false
        // console.log("show plan",this.selectedPlan)
        //hide workspace addon when plan has no licenses
        if(this.hasLicenses()){
            // this.addonTable.find('.row-type-workspace').removeClass('d-none');
                this.addonTable.find('.addon-type-workspace')
                .removeClass('addon-disabled')
                .removeAttr('data-toggle data-placement title data-original-title')
                .tooltip('dispose');            
        }else{
            // this.addonTable.find('.row-type-workspace').addClass('d-none');
            this.addonTable.find('.addon-type-workspace')
            .addClass('addon-disabled')
            .attr('data-toggle','tooltip')
            .attr('data-placement','top')
            .attr('data-original-title',`This add-on is not available on ${this.selectedPlan.name} plan.`).tooltip();
        }

        if(document.getElementById(`plan_checkbox_${this.selectedPlanId}`)){
            $(`#plan_checkbox_${this.selectedPlanId}`).prop({checked:true})
        }

        if(this.selectedPlan.has_licenses){
            this.addonLicensesClassToggle.addClass('has-licenses');
        }else{
            this.addonLicensesClassToggle.removeClass('has-licenses');
        }
        if(this.selectedPlan.plan_type == "one_time") {
            $('#billing-cycle-section').addClass('d-none')
        }

        else if(this.selectedPlan.plan_type == "recurring") {
            $('#billing-cycle-section').removeClass('d-none')
            $('#billing-cycle-section .billings').empty()
            this.selectedPlan.plan_prices.forEach(price => {
                $('#billing-cycle-section .billings').append(`
                    <div class="w-50 billing-interval">
                        <div class="billing-method-radio radio-group">
                            <input type="radio" data-price-id="${price.id}" id="price_${price.id}" name="billing-cycle" value="" class="input billing-input">
                            <label for="price_${price.id}" class="label-custom-plans interval-switch-item m-0">
                                <span class="billing-method-span d-flex f-w-400 text-lg">
                                    ${( this.selectedPlan.plan_type == "recurring" && price.interval == 'month' ?
                                        'Monthly' :
                                        this.selectedPlan.plan_type == "recurring" && price.interval == 'year' ?
                                        'Annually' :
                                        this.selectedPlan.plan_type == "one_time" ? '' : ''
                                        )
                                    }
                                </span>
                                ${ (price.interval == 'nothing' ? `
                                        <span class="save-span">Save ${( (((this.selectedPlan.price*12) - price.price)/(this.selectedPlan.price*12)) * 100 ).toFixed(0)}%</span>
                                    ` : '')
                                }
                            </label>
                        </div>
                    </div>
                `)
            })
        }
        if(this.selectedPlan) {
            let first_plan = null;
            if(this.selectedPlan.plan_prices && this.selectedPlan.plan_prices.length > 0) {
                first_plan = this.selectedPlan.plan_prices.find(p=>p.interval==this.selectedPriceInterval);
            }
            if(first_plan) {
                this.selectedPrice = first_plan;
                this.selectedPriceId=first_plan.id;
                $(`input[data-price-id="${first_plan.id}"]`).click()
            }
            this.updateAddonMaxQty()
            if(this.selectedPlan.owned && this.selectedPrice && this.selectedPrice.id == this.selectedPlan.owned_price){
                this.disableOrderButton()
            }else{
                this.enableOrderButton();
            }
        }
    }

    async reviewOrder(e) {
        this.discount = 0;
        $('#promo-code-total').addClass('d-none')
        this.selectedAddonsIds = []
        this.selectedAddonPriceIds = []
        this.selectedAddons = []
        this.addonsPrices = 0;
        this.addonTaxablePrices=0;


        if(!this.firstNameField.val().length) {
            this.firstNameError.text('First name is required.')
            this.firstNameField.focus()
            return
        }
        if(!this.lastNameField.val().length) {
            this.lastNameError.text('Last name is required.')
            this.lastNameField.focus()
            return
        }
        if(!this.emailField.val().length) {
            this.emailError.text('Email is required.')
            this.emailField.focus()
            return
        }
        if(!this.addressField.val().length) {
            this.addressError.text('Address is required.')
            this.addressField.focus()
            return
        }
        if(!this.cityField.val().length) {
            this.cityError.text('City is required.')
            this.cityField.focus()
            return
        }
        if(!this.postalCodeField.val().length) {
            this.postalCodeError.text('Postal code is required.')
            this.postalCodeField.focus()
            return
        }
        if(!this.countryField.val() || !this.countryField.val().length) {
            this.countryError.text('Country is required.')
            this.countryField.focus()
            return
        }

        if(!this.selectedPlanId) {
            this.planError.text('Plan is required.')
            $('[name="selected_plan"]').focus()
            return false;
        }


        if(this.selectedPlan && this.selectedPlan.plan_type == "recurring"){
            if(!this.selectedPriceId) {
                this.billingCycleError.text('Billing Cycle is required.')
                $('[name="billing-cycle"]').focus()
                return false
            }
        } else {
            // selecting first price if it is one time
            this.selectedPriceId = this.selectedPlan.plan_prices[0].id
        }

        this.promoCodeError.text('')
        this.removeModalContentTimeout = null

        // checking for addons
        let selected_options = $('#addons-list input[name="selected_addon"]:checked')
        selected_options.each((index, element) => {
            this.selectedAddonsIds.push($(element).data('plan-id'))
        })
        $('#addons-section').html('')


        if(!document.querySelector('#privacy_policy').checked) {
            $('#privacy_policy_error').text('Privacy policy is required.');
            return false
        }

        if(!this.cardHolderName || !this.cardHolderName.val().length) {
            this.cardHolderNameError.text('Card holder name is required.')
            this.cardHolderName.focus()
            return
        }
        let planQty=1;
        if(this.selectedPlan) {
            // console.log("Selected plan",this.selectedPlan);
            // console.log("selected pricing",this.selectedPrice)
            // let licenses = 1;
            if(this.selectedPlan.has_licenses) {
                planQty=Math.max(this.selectedPlan.qty,this.selectedPlan.min_licenses);
            }
            // $('#review-order-plan-name').text(this.selectedPlan.name)

            try {
                let billing_cycle = this.selectedPriceInterval == "year" ? "Annually" :  "Monthly";

                $('#review-order-plan-billing-cycle').text( billing_cycle )
                this.billingCycle = billing_cycle
            } catch (error) {
                this.billingCycleError.text('Billing Cycle is required.')
                return
            }

            let current_time = moment();

            if(this.selectedPlan.plan_type == "one_time") {
                $('#next-charge-row').addClass('d-none')
            } else {
                $('#next-charge-row').removeClass('d-none')
            }


            if(this.selectedPrice) {
                if(this.selectedPrice.interval == "year") {
                    current_time = current_time.add(1, 'Y');
                } else if(this.selectedPrice.interval == "month") {
                    current_time = current_time.add(1, 'M');
                }
            }
            this.nextCharge = current_time.startOf('month').format('MM/DD/YYYY')
            $('#review-order-plan-next-charge').text(this.nextCharge)

            // $('#review-order-plan-name').text(this.selectedPlan.name)
            if(this.selectedPrice.interval == "month" && this.selectedPrice.plan_type == "recurring") {
                $('#review-order-plan-billing-cycle').text('Monthly')
            } else if(this.selectedPrice.interval == "year" && this.selectedPrice.plan_type == "recurring") {
                $('#review-order-plan-billing-cycle').text('Annually')
            }

            $("#review-order-items").html('');

            //add plan row
            $("#review-order-items").append(`
                <tr>
                    <td class="px-0 text-500">Kino - ${this.selectedPlan.name}</td>
                    <td class="text-500">${planQty}</td>
                    <td class="text-right px-0 text-500">$${this.selectedPrice.price/100}</td>
                    <td class="text-right px-0">$${(this.selectedPrice.price * planQty)/100}</td>
                </tr>
            `)

            const addonQTY=this.hasLicenses() ? this.getSelectedAddonIds() : this.getCheckboxSelectedAddons();
            console.log("Selected addon ids",addonQTY);
            if(addonQTY.length > 0) {
                addonQTY.forEach(selected=>{
                    const addon=this.addonList.find(a=>a.id==selected.id);
                    if(addon && (addon.type=='addon' || (this.hasLicenses() && addon.type=='workspace'))){
                        const price=this.selectedPriceInterval == "month" ? addon.month_price : addon.year_price;
                        
                        this.addonsPrices += (price/100) * selected.qty;
                        if(addon.taxable){
                            this.addonTaxablePrices+=(price/100) * selected.qty;
                        }

                        $('#review-order-items').append(`
                            <tr>
                                <td class="px-0 text-500">${addon.name} (Add-on)</td>
                                <td class="text-500">${selected.qty}</td>
                                <td class="text-right px-0 text-500">$${(price/100).toFixed(2)}</td>
                                <td class="text-right px-0">$${((price/100) * selected.qty).toFixed(2)}</td>
                            </tr>
                        `)

                    }


                })
            }

            let total_price = (this.selectedPrice.price * planQty) / 100;
            total_price = (total_price > 0) ? total_price : 0;
            let taxableSubtotal=total_price + this.addonTaxablePrices;
            let discountTaxableSubtotal=0;
            total_price += this.addonsPrices


            if(this.promoCodeField.val()) {

                this.loading_circle.modalShow(document.querySelector('#review-order-modal .modal-body .content'))
                $('#close-review-modal-btn').addClass('d-none')
                $('#review-order-modal .modal-footer').addClass('d-none')
                $('#review-order-modal .modal-body .content').addClass('d-none')
                if(this.promoCodeField.val()) {
                    let result = await axios.post(`/ajax/promo-code/${this.promoCodeField.val()}`, {
                        plan_price_id: this.selectedPrice.id
                    }).then(res => {
                        // first version
                        if(res.data.coupon.percent_off) {
                            this.discount = (res.data.coupon.percent_off / 100 * (total_price))
                            discountTaxableSubtotal = (res.data.coupon.percent_off / 100 * (taxableSubtotal))
                        } else if (res.data.coupon.amount_off) {
                            this.discount = (res.data.coupon.amount_off / 100)
                            discountTaxableSubtotal= (res.data.coupon.amount_off / 100);
                        }
                        $('#promo-code-discount-value span').text(`- $${this.discount.toFixed(2)}`)
                        $('#promo-code-total').removeClass('d-none')
                        return true
                    }).catch(err => {
                        $('#promo-code-discount-value span').text(`- $0`)

                        if(err.response.data) {
                            if(err.response.data.promo_code) {
                                this.promoCodeError.text("" + err.response.data.promo_code[0])
                                this.promoCodeField.focus();
                            }
                        }
                        return false;
                    }).finally( () => {
                        this.loading_circle.modalHide($('#review-order-modal .modal-body'))
                        $('#close-review-modal-btn').removeClass('d-none')
                        $('#review-order-modal .modal-footer').removeClass('d-none')
                        $('#review-order-modal .modal-body .content').removeClass('d-none')
                    } )
                    if(result == false) {
                        $('#review-order-modal').modal('hide')
                        return
                    }
                }
            }
        
            total_price=Math.max((total_price-this.discount),0);
            taxableSubtotal = Math.max((taxableSubtotal - discountTaxableSubtotal),0);
            //calculate taxes and fees
            
            let taxes=await this.getTax();
            let taxesAmount=0.00;
            total_price=total_price.toFixed(2);
            let totalPriceWithTaxes=total_price;
            if(taxes > 0){
                taxesAmount=parseFloat((taxableSubtotal*(taxes/100)).toFixed(2));
                totalPriceWithTaxes=parseFloat(total_price)+taxesAmount;
            }
            console.log(`Calculating taxes (${taxes}): No taxes price :${taxableSubtotal}, With taxes price: ${totalPriceWithTaxes}, Taxes:${taxesAmount}`);
            // totalPriceWithTaxes = totalPriceWithTaxes - this.discount;
            this.totalPrice = totalPriceWithTaxes

            $("#review-order-plan-fees").html(`$${taxesAmount}`);
            // $('#review-order-plan-amount').text(`$${this.selectedPrice.price/100}`)
            $('#review-order-plan-total').html(`<strong>$${totalPriceWithTaxes.toFixed(2)}</strong>`)
            $('#review-order-modal').modal()

        }
    }
    async getTax(){
        try {
            let res=await axios.get('/ajax/plans/tax');
            return res.data.tax;
        } catch (error) {
            return 0;
        }
    };

    disableOrderButton(){
        this.reviewOrderBtn.prop({disabled:true});
    }
    enableOrderButton(){
        this.reviewOrderBtn.prop({disabled:false});
    }
    async makeOrder(e) {

        this.loading_circle.buttonShow($('#make-order-btn'))
        $('#back-order-btn').addClass('invisible')
        $('#close-review-modal-btn').addClass('invisible')
        // $('#make-order-btn').addClass('d-none')
        // $('#make-order-btn').attr('disabled', true);
        $('#loading-icon').removeClass('d-none')

        this.paymentMethod = await this.stripe.createPaymentMethod({
            type: 'card',
            card: this.cardElement,
            billing_details: {
                name: this.cardHolderName.val(),
            },
        }).then(res => res)


        // check if card payment method is successful
        if(this.paymentMethod.paymentMethod) {
            // one time charge
            if(this.selectedPlan.plan_type == "one_time") {
                axios.post('/ajax/charge', {
                    plan: this.selectedPlanId,
                    paymentMethod: this.paymentMethod.paymentMethod.id
                }).then(res => {
                    if(res.data.error){
                        $('#review-order-modal').modal('hide')
                        $("#payment-general-error").html(res.data.error);
                        return;
                    }
                    if(res.data.success == false) {
                        $('#review-order-modal').modal('hide')
                        this.cardError.text("" + res.data.message)
                    } else if(res.data.success == true) {
                        $('#review-order-modal').modal('hide')
                        $('#success-message').text(res.data.message)
                        $('#success-payment-modal').modal()
                    }
                }).catch(err => {
                    $('#review-order-modal').modal('hide')
                }).finally(() => {
                    $('#loading-icon').addClass('d-none')
                    $('#make-order-btn').removeClass('d-none')
                    $('#make-order-btn').attr('disabled', false);
                })

            // recurring plans
            } else if (this.selectedPlan.plan_type == "recurring") {
                const workspaceAddon=this.addonList.filter(a=>a.type=='workspace').map(a=>a.id);
                let selectedAddons=this.hasLicenses() ? this.getSelectedAddonIds() : this.getCheckboxSelectedAddons();
                if(!this.selectedPlan.has_licenses){
                    selectedAddons=selectedAddons.filter(a=>!workspaceAddon.includes(a.id));
                }
                const licenses=this.selectedPlan.has_licenses ? Math.max(this.selectedPlan.qty,this.selectedPlan.min_licenses) : 1;
                let request_data = {
                    first_name: this.firstNameField.val(),
                    last_name: this.lastNameField.val(),
                    company: this.companyField.val(),
                    postal_code: this.postalCodeField.val(),
                    email: this.emailField.val(),
                    address: this.addressField.val(),
                    address2: this.apartmentField.val(),
                    city: this.cityField.val(),
                    country: this.countryField.val(),
                    region: this.regionField.val(),
                    priceId: this.selectedPrice.id,
                    paymentMethod: this.paymentMethod.paymentMethod.id,
                    last_four: this.paymentMethod.paymentMethod.card.last4,
                    cardLastFour: this.paymentMethod.paymentMethod.card.last4,
                    nextCharge: this.nextCharge,
                    price: this.selectedPrice.price.toFixed(2),
                    totalPrice: this.totalPrice,
                    billingCycle: this.billingCycle,
                    addons: selectedAddons,
                    planId: this.selectedPlanId,
                    interval: this.selectedPriceInterval,
                    licenses: licenses
                }

                if(this.promoCodeField.val()) {
                    request_data['discount']        = this.discount
                    request_data['promo_code']      = this.promoCodeField.val()
                }


                axios.put(`/ajax/subscribe`, request_data).then(res => {
                    if(res.data.error){
                        $('#review-order-modal').modal('hide')
                        $("#payment-general-error").html(res.data.error);
                        return;
                    }
                    if(res.data.success == false) {
                        $('#review-order-modal').modal('hide')
                        this.cardError.text("" + res.data.message)
                    } else if(res.data.success == true) {
                        $('#review-order-modal').modal('hide')
                        $('#plan-purchase-title').html(res.data.payment_error ? 'Payment error' : 'Thank you')
                        $('#success-message').html(res.data.message)

                        $('#plan-purchase-icon').html(res.data.payment_error ? `<i class="fa fa-warning f-s-5rem" style="color: #032836" aria-hidden="true"></i>` : `<i class="fa fa-check-circle f-s-5rem" style="color: #032836" aria-hidden="true"></i>`)
                        $('#success-payment-modal').modal()
                    }
                }).catch(err => {
                    if(err.response.data) {
                        if(err.response.data.promo_code) {
                            this.promoCodeError.text("" + err.response.data.promo_code[0])
                            this.promoCodeField.focus();
                        }
                    }
                    $('#review-order-modal').modal('hide')
                }).finally(() => {
                    $('#back-order-btn').removeClass('invisible')
                    $('#close-review-modal-btn').removeClass('invisible')
                    $('#loading-icon').addClass('d-none')
                    $('#make-order-btn').removeClass('d-none')
                    $('#make-order-btn').attr('disabled', false);
                    this.loading_circle.buttonHide($('#make-order-btn'))
                })
            }
        } else if(this.paymentMethod.error) {
            this.cardError.text("" + this.paymentMethod.error.message)
            $('#review-order-modal').modal('hide')
            $('#loading-icon').addClass('d-none')
            $('#make-order-btn').removeClass('d-none')
            $('#make-order-btn').attr('disabled', false);
            this.loading_circle.buttonHide($('#make-order-btn'))
        }

    }

}
